import { render } from "./Notification.vue?vue&type=template&id=b258b110"
const script = {}
script.render = render

export default script